<template>
  <section id="ourfaq" class="bglight position-relative padding">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center wow fadeIn" data-wow-delay="300ms">
          <h2 class="heading bottom40 darkcolor font-light2">
            <span class="font-normal">Validasi Dokumen TTE</span>
            <span class="divider-center"></span>
          </h2>
          <div class="col-md-8 offset-md-2 heading_space">
            <p>
              <!-- Lorem ipsum dolor sit amet, consectetur adipisicing elit. A dolores
        explicabo laudantium, omnis provident quam reiciendis voluptatum? -->
            </p>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 pr-lg-0 whitebox noshadow">
          <b-overlay :show="loadingCard" rounded="sm">
            <div class="widget logincontainer" v-if="!loadingCard">
              <center v-if="resultData != null && resultData.summary == 'VALID'">
                <img
                  src="img/success.png"
                  style="width: 80px"
                  class="text-center"
                  alt=""
                />
                <br />
                <br />
                <h3 class="text-success">Dokumen Valid</h3>
              </center>
              <center v-if="resultData == null || resultData.summary != 'VALID'">
                <img
                  src="img/error.png"
                  style="width: 80px"
                  class="text-center"
                  alt=""
                />
                <br />
                <br />
                <h3 class="text-danger">Url Tidak Valid</h3>
              </center>
              <br />
              <br />
              <table class="table" v-if="resultData">
                <tr>
                  <th style="width: 30%">Nama Dokumen</th>
                  <th>: {{ resultData.nama_dokumen }}</th>
                </tr>
                <tr>
                  <th style="width: 30%">Catatan</th>
                  <th>: {{ resultData.notes }}</th>
                </tr>
                <tr v-if="resultData.summary == 'VALID'">
                  <th style="width: 30%">Tanggal Tanda Tangan</th>
                  <th>: {{ formatDate(resultData.signed_in) }}</th>
                </tr>
              </table>
            </div>
          </b-overlay>
        </div>
        <!-- <div class="col-lg-6 d-none d-lg-block pl-lg-0">
          <div class="image login-image h-100">
            <img src="/img/auth-bg.png" alt="" />
          </div>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useAuthStore } from "@/store/auth";
import { useToast, TYPE } from "vue-toastification";
import JwtService from "@/core/services/JwtService";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "LoginView",
  components: {},
  setup() {
    const authStore = useAuthStore();
    const loadingCard = ref(false);
    const toast = useToast();
    const route = useRoute();

    const uuid = route.query.token as string;
    // console.log("uuid", uuid);

    const resultData: any = ref(null);
    // console.log("resultData", resultData.value);
    const getData = async () => {
      loadingCard.value = true;
      await authStore
        .validateTTE(uuid)
        .then((res) => {
          loadingCard.value = false;
          resultData.value = res.data.data;
        })
        .catch((err) => {
          loadingCard.value = false;
          resultData.value = null;
        });
    };

    const formatDate = (dates: string) => {
      let dateStr = dates;
      let dateObj = new Date(dateStr);

      let day = String(dateObj.getDate()).padStart(2, "0");
      let month = String(dateObj.getMonth() + 1).padStart(2, "0"); // January is 0!
      let year = dateObj.getFullYear();

      let hours = dateObj.getHours();
      let minutes = dateObj.getMinutes();

      let newDateStr = `${day}/${month}/${year} ${hours}.${minutes}`;

      return newDateStr;
    };

    onMounted(async () => {
      await getData();
    });

    return {
      loadingCard,
      authStore,
      toast,
      resultData,
      formatDate,
    };
  },
});
</script>
